import Solat from "./Solat";
import HomePromoCards from "./HomePromoCards";
import "../styles/HomeHero.css";

export default function HomeHero() {
  return (
    <section className="home-hero" aria-label="Waktu solat dan kemudahan Etikaf">
      <div className="home-hero-prayer">
        <Solat />
      </div>
      <HomePromoCards />
    </section>
  );
}
